import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendReviewList from '../RecommendReviewList';
import RecommendReviewListSearchBox from '../RecommendReviewListSearchBox';

const RecommendReviewListWrap = (props) => {
  const { recommendReviewList, setData, getList } = props;

  return (
    <div className="recommend-review-list-wrap">
      {/* 추천 상품 후기 검색 박스*/}
      <RecommendReviewListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendReviewList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendReviewList.searchData}
        getList={getList}
      />

      {/* 추천 상품 후기 리스트*/}
      <RecommendReviewList
        recommendReviewList={recommendReviewList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendReviewList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendReviewListWrap;
